/**
 * Validate forms
 */

function isOjlEmpty(value) {
  return value == '';
}

function isOjlEmptyRadio(field) {
  var empty = false;

  var len = jQuery('input:radio[name="'+field+'"]:checked').size();

  if(len == 0){
    empty = true;
  }
  return empty;
}

function isOjlEmptyCheckbox(fieldId) {
  var empty = false;

  var len = jQuery('input:checkbox[id="'+fieldId+'"]:checked').size();
  if(len == 0){
    empty = true;
  }
  return empty;
}
function isOjlEmptyRadio(field) {
   var radioObj = document.formName.radioGroupName;

   for(var i=0; i<radioObj.length; i++) {
       if( radioObj[i].checked ) {
          return true;
      }
   }

   return false;
 }

function isOjlAnInvalidEmail(value) {
  var email = value;

  var ok = "1234567890qwertyuiop[]asdfghjklzxcvbnm.@-_QWERTYUIOPASDFGHJKLZXCVBNM";

  for(i = 0; i < email.length; i++){
    if(ok.indexOf(email.charAt(i)) < 0) {
      return true;
    }
  }

  re = /(@.*@)|(\.\.)|(^\.)|(^@)|(@$)|(\.$)|(@\.)/;
  re_two = /^.+\@(\[?)[a-zA-Z0-9\-\.]+\.([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  return re.test(email) || !re_two.test(email);
}

function showOjlErrorAndFocusIf(fieldId, predicate, errorId) {
  if (fieldId == 'terms') {
    var field = fieldId;
  } else {
    var field = document.getElementById(fieldId);

  }

  if (predicate(field)) {

    document.getElementById(errorId).style.display = 'block';
    document.getElementById(errorId).closest('.register-field, .donation-details-section').classList.add('error');
    if (field == 'terms') {
      field = document.getElementById(field);
    }
    if (field.select) {
      field.select();
    }
    field.focus();
    return false;
  }

  return true;
}

function hideAllOjlFormErrors() {
  document.getElementById("emailError").style.display = "none";
  document.getElementById("emailError").closest('.register-field').classList.remove('error');
  document.getElementById("emailError2").style.display = "none";
  document.getElementById("emailError2").closest('.register-field').classList.remove('error');
  //document.getElementById("termsError").style.display = "none";
  //document.getElementById("termsError").closest('.register-field').classList.remove('error');
  document.getElementById("firstnameError").style.display = "none";
  document.getElementById("firstnameError").closest('.register-field').classList.remove('error');
  document.getElementById("lastnameError").style.display = "none";
  document.getElementById("lastnameError").closest('.register-field').classList.remove('error');
  //document.getElementById("addressError").style.display = "none";
  //document.getElementById("addressError").closest('.form-field').classList.remove('error');
  //document.getElementById("zipcodeError").style.display = "none";
  //document.getElementById("zipcodeError").closest('.form-field').classList.remove('error');
  //document.getElementById("cityError").style.display = "none";
  //document.getElementById("cityError").closest('.form-field').classList.remove('error');
  //document.getElementById("targetError").style.display = "none";
}

function showOjlFieldError(value) {
  if (value == 'emailInvalid') {
    var errorId = 'emailError2';
  } else {
    var errorId = value + 'Error';
  }

  document.getElementById(errorId).style.display = 'block';
  if (value != 'target') {
    document.getElementById(errorId).closest('.register-field, .donation-details-section').classList.add('error');
  }
  if (value == 'emailInvalid') {
    var field = document.getElementById('email');
  } else {
    var field = document.getElementById(value);
  }
  if (field == 'terms') {
    field = document.getElementById(field);
   }
  if (field) {
    if (field.select) {
      field.select();
    }
    field.focus();
  }
}


function validateOjlPresentForm() {
  hideAllOjlFormErrors();

  var requiredElements = document.querySelectorAll('.register-field.required input');
  var i;
  var formIsValid = true;
  var errors = [];


  for (i = 0; i < requiredElements.length; i++) {
    var fieldId = requiredElements[i].id;
    var value = requiredElements[i].value;
    var isInvalidEmail = false;

    var fieldEmpty = false;

    if (fieldId == 'terms') {
      var fieldEmpty = isOjlEmptyCheckbox(fieldId);
    } else {
      var fieldEmpty = isOjlEmpty(value);
    }

    if (fieldId == 'email' && !fieldEmpty) {
      isInvalidEmail = isOjlAnInvalidEmail(value);
    }

    if (fieldEmpty) {
      errors.push(fieldId);
      formIsValid = false;
    }

    if (isInvalidEmail) {
      errors.push('emailInvalid');
      formIsValid = false;
    }


  }

  if (errors.length > 0) {
    errors.forEach(showOjlFieldError);
  }

  return formIsValid;
}
